import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import {
  EDIT_USER,
  POINT_SERVICE,
  UTILISATEUR_PAR_ROLE_PARENT,
} from "../../Utils/constant";
import { find, store } from "../../services/service";
import { useRoleStore } from "../../store/RoleStore";
import { useStoreUser } from "../../store/user";

export const EditerUtilisateur = ({ item }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [error, setError] = useState(false);
  const [select, setSelect] = useState();
  const [typeAgent, setTypeAgent] = useState("");
  const [superviseur, setSuperviseur] = useState();
  const [pointService, setPointService] = useState([]);
  const [listSuperviseur, setListSuperviseur] = useState([]);

  const users = useStoreUser();
  const role = useRoleStore();

  const pointServiceList = (type) => {
    find(`${POINT_SERVICE}?typePs=${type}`).then((result) => {
      setPointService(result?.data?.donnee);
    });
  };

  const superviseurList = (id) => {
    store(`${UTILISATEUR_PAR_ROLE_PARENT}`, "application/json", {
      id: id,
    })
      .then((result) => {
        setError(null);
        setListSuperviseur(result?.data?.donnee);
      })
      .catch((e) => {
        setError(e?.response?.data?.donnee);
      });
  };

  const submit = (data) => {
    setIsSubmit(true);
    store(EDIT_USER, "application/json", { ...data, id: item?.id })
      .then((res) => {  
        reset();
        setIsSubmit(false);
        if (res.status === 200) {
          users.user({ page: 0, param: "", size: 10 }, "&role=");
          toast.success("Utilisateur modifier ");
          document.getElementById(`fermer-modal${item.id}`).click();
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        console.log(err);
        setError(err?.response?.data?.donnee);
      });
  };

  useEffect(() => {
    reset();
    if (item) {
      reset();
    }
  }, [reset, item]);

  return (
    <div className="">
      {/* Header */}
      <div className="mb-8">
        <h2 className="text-2xl font-mtn font-bold text-gray-900 mb-2">
          Modification d'utilisateur
        </h2>
        <p className="text-gray-600 text-sm">
          Remplissez les informations ci-dessous pour créer un compte
          utilisateur
        </p>
      </div>

      {/* Error Message */}
      {error && (
        <div className="mb-6 p-4 rounded-lg border border-red-200 bg-red-50">
          <p className="text-sm text-red-600 flex items-center">
            <svg
              className="w-4 h-4 mr-2"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                clipRule="evenodd"
              />
            </svg>
            {error}
          </p>
        </div>
      )}

      <form onSubmit={handleSubmit(submit)} className="space-y-8">
        {/* Section 1: Informations personnelles */}
        <div className="bg-gray-50 rounded-xl p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
            <svg
              className="w-5 h-5 mr-2 text-blue-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
            Informations personnelles
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nom et prénoms <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="ex : Yao Koffi"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                {...register("nomPrenoms", {
                  required: "Ce champ est obligatoire",
                })}
                defaultValue={item?.nomPrenoms}
              />
              {errors.nomPrenoms && (
                <p className="mt-1 text-sm text-red-600 flex items-center">
                  <svg
                    className="w-4 h-4 mr-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  {errors.nomPrenoms.message}
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Username <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="ex : @yao"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                {...register("username", {
                  required: "Ce champ est obligatoire",
                })}
                defaultValue={item?.username}
              />
              {errors.username && (
                <p className="mt-1 text-sm text-red-600 flex items-center">
                  <svg
                    className="w-4 h-4 mr-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  {errors.username.message}
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                placeholder="ex : kofi@yao.ee"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                {...register("email", {
                  required: "Ce champ est obligatoire",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Adresse email invalide",
                  },
                })}
                defaultValue={item?.email}
              />
              {errors.email && (
                <p className="mt-1 text-sm text-red-600 flex items-center">
                  <svg
                    className="w-4 h-4 mr-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  {errors.email.message}
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Numéro de téléphone <span className="text-red-500">*</span>
              </label>
              <input
                type="tel"
                placeholder="ex : 002587663321"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg "
                {...register("numero", {
                  required: "Ce champ est obligatoire",
                })}
                defaultValue={item?.numero}
              />
              {errors.numero && (
                <p className="mt-1 text-sm text-red-600 flex items-center">
                  <svg
                    className="w-4 h-4 mr-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  {errors.numero.message}
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Section 2: Rôle et hiérarchie */}
        <div className="bg-gray-50 rounded-xl p-6">
          <h3 className="font-mtn text-lg font-semibold text-gray-900 mb-4 flex items-center">
            <svg
              className="w-5 h-5 mr-2 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.031 9-11.622 0-1.042-.133-2.052-.382-3.016z"
              />
            </svg>
            Rôle et hiérarchie
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Rôle <span className="text-red-500">*</span>
              </label>
              <select
                {...register("role", {
                  required: "Veuillez sélectionner un rôle",
                })}
                onChange={(e) => {
                  superviseurList(e.target.value);
                  setSelect(
                    role?.data?.data?.find(
                      (roleId) => roleId.id === e.target.value
                    )?.typeProfile
                  );
                }}
                className="select w-full"
              >
                <option value="">Choisissez un rôle</option>
                {role?.data?.data?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item?.id
                      ?.replace(/ROLE_/g, " ")
                      .replace(/_/g, " ")
                      .toLowerCase()}
                  </option>
                ))}
              </select>
              {errors.role && (
                <p className="mt-1 text-sm text-red-600 flex items-center">
                  <svg
                    className="w-4 h-4 mr-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  {errors.role.message}
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Superviseur <span className="text-red-500">*</span>
              </label>
              <select
                {...register("superviseurId")}
                onChange={(e) => setSuperviseur(e.target.value)}
                className="select w-full"
              >
                <option value="">Sélectionnez un superviseur</option>
                {listSuperviseur?.map((item) => (
                  <option key={item?.id} value={item?.id}>
                    {item?.nomPrenoms}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Section 3: Configuration commerciale (conditionnelle) */}
        {select === "AGENCE" && (
          <div className="bg-blue-50 rounded-xl p-6 border border-blue-200">
            <h3 className="font-mtn text-lg font-semibold text-gray-900 mb-4 flex items-center">
              Configuration Agence
            </h3>

            <div className="space-y-6">
              {select === "AGENCE" && (
                <div className="pl-4 border-l-4 border-blue-300 space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Type d'agence <span className="text-red-500">*</span>
                    </label>
                    <select
                      onChange={(e) => pointServiceList(e.target.value)}
                      className="w-full select"
                    >
                      <option value="">Sélectionnez un type</option>
                      <option value="POINT_CONNECT">Point connect</option>
                      <option value="SERVICE_CENTER">Service center</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Agence <span className="text-red-500">*</span>
                    </label>
                    <select
                      {...register("pointServiceId")}
                      className="w-full select"
                    >
                      <option value="">Sélectionnez une agence</option>
                      {pointService.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.designation}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Actions */}
        <div className="flex justify-end space-x-4 pt-6 border-t border-gray-200">
          <button
            type="submit"
            disabled={isSubmit}
            className={`px-8 py-3 rounded-lg font-medium transition-all duration-200 flex items-center space-x-2 ${
              !isSubmit
                ? "bg-main text-black"
                : "bg-gray-300 text-gray-500 cursor-not-allowed"
            }`}
          >
            {isSubmit ? (
              <>
                <svg
                  className="animate-spin h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <span>Traitement en cours...</span>
              </>
            ) : (
              <>
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
                <span>Ajouter l'utilisateur</span>
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};
